module.exports = __webpack_public_path__ + "img/room_wide.c8eddf2f.jpg";